export const PATTERNS = {
  polishLetters: 'A-Za-zżźćńółęąśŻŹĆĄŚĘŁÓŃ',
  asciiLetters: 'A-Za-z',
  numbers: '\\d',
  phone: /^\+?\d+/g,
  specialCharacters: '\\\\!#$%&\'*+\\-/=?^_`{|}~"():;<> @[\\]',
  email: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
  ddMmYyyy: /^(([0-2][0-9])?|(3)[0-1])(\.)(((0)[0-9])|((1)[0-2]))(\.)\d{4}$/i
};
